import * as React from 'react';
import { flow, forEach, map, mapValues, filter, cloneDeep, size, get } from 'lodash';
import { II18nMessages } from '../../../../services/branding/models';
import { Button, Col, Form, Row, ControlLabel } from 'react-bootstrap';
import { Field, FieldArray, formValueSelector, InjectedFormProps, reduxForm, submit, reset, destroy } from 'redux-form';
import { isRequired } from '../../../../util/validators';
import TravellersMedical from './components/TravellersMedical';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {IChannel, IDeclaration, IProduct, ITraveller} from '../../../../data/api/models';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import FieldFormControl from '../../../../components/FieldFormControl/index';
import * as ReactMarkdown from 'react-markdown';
import confirm from 'react-confirm2';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import FaChevronRight from 'react-icons/fa/chevron-right';
import { IStore } from '../../../../redux/IStore';

// tslint:disable:max-line-length
// FIXME: This should come from the API!
const WARNING_MESSAGE = {
  default: `We notice that you have ticked ‘Yes’ to one or more of the Medical Screening questions,
              but you have not declared any medical conditions. Unfortunately, if you do not declare
              all relevant medical conditions, your policy could get cancelled,
              claim payments refused or your claim rejected.
              Are you happy to proceed?`,
  MPT: `We notice that you have ticked ‘Yes’ to one or more of the Medical Screening questions, but you have not declared any medical conditions. Unfortunately, if you do not declare all relevant medical conditions, your policy could get cancelled, claim payments refused or your claim rejected. Are you happy to proceed?\n\n **IMPORTANT NOTE** : If you or anyone else to be insured reside in the United Kingdom or the Isle of Man and your trip is to or within the United Kingdom or the Isle of Man, you do not need to declare any medical conditions. Please click **OK** to continue.`,
  LSB: `As you have answered ‘Yes’ to one or more of the Medical Screening questions, you must now contact Travel Administration Facilities at [www.pjhlongstay.protectif.co.uk](http://www.pjhlongstay.protectif.co.uk) or call them on 0203 829 3855. They will tell you if your pre-existing medical condition/s can be covered. This can be done when you save the quote or after purchasing cover.\n\n **Please note:** We are unable to provide any cover for your medical pre-existing condition, unless we have agreed cover in writing and any additional premium has been paid.`,
};

interface IMedicalDeclaration extends InjectedFormProps {
  i18n: II18nMessages;
  product: IProduct;
  pristine: boolean;
  quote: IQuoteState;
  submitting: boolean;
  onBack: () => void;
  dispatch: any;
  traveller: ITraveller;
  travellers: ITraveller[];
  channel: IChannel;
  medicalDeclaration: IDeclaration[];
  cancelMedicalDeclaration: boolean;
  renderDefinition(name: string): any;
  actions: {
    submit(name: string);
    quote: IQuoteActions;
    reset(formName: string);
    destroy(formName: string);
  };
}

interface IMedicalDeclarationState {
  isScreening: boolean;
  isTerminal: boolean;
  isAnyModalOpen: boolean;
  unableToProvideQuote: boolean;
  cancelMedicalDeclaration: boolean;
}

class MedicalDeclaration extends React.Component<IMedicalDeclaration, IMedicalDeclarationState> {
  public state = {
    isScreening: false,
    isTerminal: false,
    isAnyModalOpen: false,
    unableToProvideQuote: false,
    cancelMedicalDeclaration: false,
  };

  public componentWillMount() {
    const { product, change, medicalDeclaration, dispatch, quote } = this.props;
    const steps = quote.application.steps;
    let allowEmailSendLogic = true;

    forEach(steps, (step) => {
      if (step.match(/(schemeChoice)/)) {
        allowEmailSendLogic = false;
      }
    });

    if (allowEmailSendLogic) {
      dispatch(change('emailSend', true));
    }

    if (size(medicalDeclaration) === 0) {
      change(
        'medicalDeclaration',
        mapValues(cloneDeep(
          product.metadata.medical_declaration_questions),
          (declaration) => ({ ...declaration, answer: undefined }),
        ),
      );
    }
  }

  private scrollToBottom() {
    const element = document.getElementById('medical-screening-questions');
    element.scrollIntoView({ behavior: 'smooth' });
  }

  private shouldShowScreeningSection = () => {
    const { medicalDeclaration, product, cancelMedicalDeclaration } = this.props;

    if (product.productCode === 'CPS' && cancelMedicalDeclaration) {
      return true;
    }

    if (! medicalDeclaration) {
      return false;
    }

    const allQuestions = filter(medicalDeclaration, (question) => {
      return question.question_type === 'boolean';
    });

    const medicalQuestions = filter(medicalDeclaration, (question) => question.category === 'medical');
    const unanswered = filter(allQuestions, (question) =>
      question.answer === undefined && question.question_type === 'boolean',
    );
    const trueAnswers = filter(medicalQuestions, (question) => question.answer === true);

    return unanswered.length === 0 && trueAnswers.length > 0;
  }

  private setIsScreening = (isScreening: boolean) => {
    this.setState({
      isScreening,
    });
  }

  private checkForTerminalCondition = (item) => {
    const { actions, quote } = this.props;
    if (item.category === 'health' && item.answer === true) {
      // this.setState({ unableToProvideQuote: true });
      // actions.quote.referralQuote(quote.application.id, null);
    }
  }

  private renderMedicalQuestion = (item, key) => {
    let component = null;

    if (item.question_type === 'boolean') {
      component = [
        (
          <Col xs={6} key={1}>
            <Field
              name={`medicalDeclaration[${key}].answer`}
              id={`medicalDeclaration[${key}].answerYes`}
              type="radio"
              format={null}
              value={true}
              complexValue={true}
              className="answer"
              component={FieldFormControl}
              validate={[ isRequired ]}
              onClick={this.checkForTerminalCondition(item)}
            >
              <div className="medical-btn yes">
                Yes
              </div>
            </Field>
          </Col>
        ),
        (
          <Col xs={6} key={2}>
            <Field
              name={`medicalDeclaration[${key}].answer`}
              id={`medicalDeclaration[${key}].answerNo`}
              type="radio"
              format={null}
              value={false}
              complexValue={true}
              className="answer"
              component={FieldFormControl}
              validate={[ isRequired ]}
            >
              <div className="medical-btn no">
                No
              </div>
            </Field>
          </Col>
        ),
      ];
    }

    if (item.question_type === 'number') {
      component = (
        <div>
          <Field
            name={`medicalDeclaration[${key}].answer`}
            className="answer-number"
            component={FieldFormControl}
          />
        </div>
      );
    }

    return (
      <div className="medical-question medical-section" key={key}>
        <Row>
          <Col sm={12}>
            <ReactMarkdown source={item.content} />
          </Col>
          <Col sm={4}>
            {component}
          </Col>
        </Row>
      </div>
    );
  }

  private renderMedicalHeader = (item, key) => {
    return (
      <div key={key}>
        <p>
          <ReactMarkdown
            source={item.content}
            renderers={{
              link: (props) => (
                <a href={props.href} target="_blank">
                  {props.children}
                </a>
              ),
            }}
          />
        </p>
      </div>
    );
  }

  public renderQuestions(category) {
    const { medicalDeclaration } = this.props;

    const displayKeys = [];

    forEach(medicalDeclaration, (declaration: IDeclaration) => {
      const answer = declaration.answer;
      const questionType = declaration.question_type;

      if (questionType === 'boolean' && answer === 'true') {
        if (declaration.next_key) {
          displayKeys.push(declaration.next_key);
        }

        if (declaration.true_key) {
          displayKeys.push(declaration.true_key);
        }
      }

      if (questionType === 'boolean' && answer === 'false') {
        if (declaration.next_key) {
          displayKeys.push(declaration.next_key);
        }

        if (declaration.false_key) {
          displayKeys.push(declaration.false_key);
        }
      }
    });

    return (
      <div className="medical-questions-container">
        {map(medicalDeclaration, (question: any, key) => {
          let component;

          if (question.display === false && displayKeys.indexOf(key) === -1) {
            return null;
          }

          if (['header', 'footer'].includes(question.type) && category === question.category) {
            component = this.renderMedicalHeader(question, key);
          }

          if (question.type === 'question' && category === question.category) {
            component = this.renderMedicalQuestion(question, key);
          }

          return component;
        })}
      </div>
    );
  }

  private checkIfConditionWasDeclared = () => {
    const { travellers, medicalDeclaration, actions, product } = this.props;

    const allQuestions = filter(medicalDeclaration, (question) => question.type === 'question');
    const unanswered = filter(allQuestions, (question) =>
      question.answer === undefined && question.question_type === 'boolean',
    );

    const MedicalQuestions = filter(medicalDeclaration, (question) => question.category === 'medical');
    const medicalTrueAnswers = filter(MedicalQuestions, (question) => question.answer === true);

    const travellerScreening = filter(travellers, (traveller) => traveller.screening);
    const travellersLength = travellers.length;

    const shouldScreen = unanswered.length === 0 && medicalTrueAnswers.length > 0;

    if (!shouldScreen) {
      actions.submit('quote');
      // this.agreementBeforeSubmit();
    }

    if (shouldScreen && travellerScreening.length === travellersLength) {
      actions.submit('quote');
      // this.agreementBeforeSubmit();
    }

    if (shouldScreen && travellerScreening.length < travellersLength && travellerScreening.length === 0) {
      this.setState({ isAnyModalOpen: true });
      confirm('Finish Medical Screening', {
        description: (
          <span className="medical-modal">
             {WARNING_MESSAGE[product.productCode]
               ? (
                 <ReactMarkdown
                   source={WARNING_MESSAGE[product.productCode]}
                   renderers={{
                     link: (props) => (
                       <a href={props.href} target="_blank">
                         {props.children}
                       </a>
                     ),
                   }}
                 />
               ) : (
                 <h4>{WARNING_MESSAGE.default}</h4>
               )}
            <br/>
          </span>
        ),
        done: () => {
          this.setState({ isAnyModalOpen: false });
          actions.submit('quote');
        },
        close: () => {
          this.setState({ isAnyModalOpen: false });
          return;
        },
      });
    }

    if (shouldScreen && travellerScreening.length < travellersLength && travellerScreening.length > 0) {
      actions.submit('quote');
      // this.agreementBeforeSubmit();
    }
    this.scrollToBottom();
  }
  /* tslint:disable:max-line-length */
  // private agreementBeforeSubmit = () => {
  //   const { actions } = this.props;
  //   this.setState({ isAnyModalOpen: true });
  //   confirm('Terms & Conditions', {
  //     description: (
  //       <span>
  //         <span>By clicking continue you agree to our <a href="https://www.admiral.com/insurance/your-policy/conditions-of-use.php?&contentOnly=1&_ga=2.7793211.828839540.1508235797-2125578306.1459951786&_gac=1.217769634.1505922935.EAIaIQobChMI_rW5lpC01gIVzrztCh1dwA5aEAAYASAAEgJX9PD_BwE" target="_blank">conditions of use</a> and <a href="https://www.admiral.com/your-privacy-and-security/?&contentOnly=1&_ga=2.7793211.828839540.1508235797-2125578306.1459951786&_gac=1.217769634.1505922935.EAIaIQobChMI_rW5lpC01gIVzrztCh1dwA5aEAAYASAAEgJX9PD_BwE" target="_blank">privacy statement</a></span>
  //       </span>
  //     ),
  //     done: () => {
  //       actions.submit('quote');
  //       this.setState({ isAnyModalOpen: false });
  //     },
  //     close: () => {
  //       this.setState({ isAnyModalOpen: false });
  //       return;
  //     },
  //   });
  // }

  public render() {
    const {
      i18n,
      product,
      handleSubmit,
      medicalDeclaration,
      submitting,
      valid,
      change,
      submitFailed,
      channel,
      quote,
      onBack,
    } = this.props;
    const { metadata } = product;
    const { isAnyModalOpen, unableToProvideQuote } = this.state;

    const medicalHeader = get(product, 'metadata.purchase_declaration.b2c.medical_screening.header');
    const medicalFooter = get(product, 'metadata.purchase_declaration.b2c.medical_screening.footer');

    if (! medicalDeclaration) {
      return false;
    }

    const getHeaderFromApi = ['DIA', 'ADV', 'CPS'].includes(product.productCode);
    const upperCaseList = ['dia-b2c'];
    const renderTitle = (upperCaseList.indexOf(channel.key) !== -1) ? 'Medical' : 'MEDICAL';
    // FIXME: This should be in the medical declaration content as a paragraph
    const renderPreQuestion = !['FST'].includes(product.productCode)
      ? null
      : 'Are you or anyone else to be insured on this policy:';

    const subtitleClass = ['medical-subtitle', channel.key === 'dia-b2c' && '--pb5' ].join('');
    const customClassList = ['dia-b2c'].includes(channel.key);
    const sectionClass = ['section padding-bottom-0 ', customClassList && 'section--noBorder' ].join('');
    const callMessage = {
      free: 'Simply call our UK-based specialist customer service team FREE on',
      cost: 'Simply call our UK-based specialist customer service team on',
    };
    const productCallMessage = {
      FST: callMessage.free,
      DIA: callMessage.cost,
    };
    const renderCallMessage = productCallMessage[product.productCode];

    return (
      <Form onSubmit={handleSubmit} autoComplete="off">
        <div className="steps-container">
          <div className="section-title">
            <h1>{renderTitle}</h1>
          </div>
          {!unableToProvideQuote ? (
          <div className="medical-section-group">
            <div className={sectionClass} style={{ marginBottom: '0' }}>
              <Row>
                {!getHeaderFromApi && (
                  <div>
                  <div className="internal-title">
                    Important Conditions Relating To Your Health
                  </div>
                    <p className={subtitleClass}>
                      We need to ask you some medical questions about you and anyone else to be
                      insured on the policy to make sure that you have the right cover.
                    </p>
                  </div>
                )}
                {getHeaderFromApi && (
                    <div className="medical-bold-note">
                      <ReactMarkdown source={medicalHeader} />
                    </div>
                )}
                <br />
                <h3>Medical Declaration</h3>
                <p>{renderPreQuestion}</p>
                {this.renderQuestions('health')}
              </Row>
            </div>

            <div className="section padding-bottom-0" style={{ paddingTop: '0' }}>
              <Row>
                {product.productCode === 'FST' ? (
                  <div>
                    <div className="internal-title">
                      Medical Screening
                    </div>

                    <p>
                      Please answer the following questions. If you or anyone else to be insured on
                      this policy answer ‘Yes’ to any of these you will need to go through our medical
                      screening process. If you are not sure of any of the information you are giving
                      us or do not know the answer, please check with the treating G.P.
                    </p>
                  </div>
                ) : null}
                {product.productCode !== 'CPS' ? (
                    <div>{this.renderQuestions('medical')}</div>
                ) : (
                  <p>
                    <div className="internal-title" style={{ paddingTop: '10px' }}>
                      TRAVELLING WITHIN THE UK, CHANNEL ISLANDS OR ISLE OF MAN
                    </div>
                    <p style={{ padding: '10px' }}>
                      If you are travelling in the UK, Channel Islands or Isle of Man, you are not required to declare
                      your medical conditions. However, to be covered for any medical conditions you have or have had,
                      you must be able to comply with the following:
                    </p>
                    <p style={{ padding: '10px' }}>
                      1. You are fit to travel and undertake your planned journey.
                    </p>
                    <p style={{ padding: '10px' }}>
                      2. Following any claim investigation, your doctor confirms they would have agreed with or
                      recommended your travel plans when you took out this insurance, booked your journey or at the time
                      you travelled (whichever is later).
                    </p>
                    <p style={{ padding: '10px' }}>
                      3. You are not travelling with the purpose of having medical treatment or a consultation.
                    </p>
                    <p style={{ padding: '10px' }}>
                      4. You are not awaiting the outcome of any medical tests or an appointment at a medical facility
                      for any medical investigations.
                    </p>
                    <div className="internal-title">
                      TRAVELLING OUTSIDE OF THE UK AND ALL AIR & CRUISE HOLIDAYS
                    </div>
                    <p style={{ padding: '10px' }}>
                      If you are travelling outside of the UK or are going on an Air or Cruise Holiday, you will not be
                      covered for any claims arising as a direct or indirect result of an existing medical condition if,
                      in the 12 months before taking out this insurance or booking your journey (whichever is later),
                      you:
                    </p>
                    <p style={{ padding: '10px' }}>
                      a) Were referred for tests, investigations, treatment or surgery, or were awaiting the results of
                      any referral;
                    </p>
                    <p style={{ padding: '10px' }}>
                      b) Attended or were due to attend a hospital or clinic as an outpatient or inpatient;
                    </p>
                    <p style={{ padding: '10px' }}>
                      c) Received treatment or saw a medical practitioner for a medical condition; or
                    </p>
                    <p style={{ padding: '10px' }}>
                      d) Were prescribed medication.
                    </p>
                    <p style={{ padding: '10px' }}>
                      Unless the condition(s) has (have) been declared to us and accepted in writing.
                    </p>
                    <p style={{ padding: '10px'}}>
                      <Row className="radio-horizontal">
                        <Col sm={10}>
                          <ControlLabel>
                            Please therefore <b>CLICK HERE</b> if you need to declare a medical condition. Please note
                            an additional premium may be payable.
                          </ControlLabel>
                        </Col>
                        <Col sm={2}>
                          <Field
                              name="cancelMedicalDeclaration"
                              type="checkbox"
                              component={FieldFormControl}
                              // validate={[
                              //   isRequired,
                              //   isNotFalse,
                              // ]}
                              style={{ marginTop: '0px' }}
                          >
                            <div />
                          </Field>
                        </Col>
                      </Row>
                    </p>
                    <div className="internal-title" style={{ paddingTop: '10px' }}>
                      PLEASE NOTE
                    </div>
                    <div style={{ padding: '10px' }}>
                      You will <b>NOT</b> be covered if:
                    </div>
                    <p style={{ padding: '10px' }}>
                      • Following any claim investigation, your doctor confirms they would not have agreed with or
                      recommended you travel as planned either when you took out this insurance, booked your journey or
                      at the time you travelled (whichever is later).
                    </p>
                    <p style={{ padding: '10px' }}>
                      • You know you will need medical treatment or a consultation at a medical facility during your
                      journey.
                    </p>
                    <p style={{ padding: '10px' }}>
                      • You are travelling specifically for the purpose of having surgery, procedures or hospital
                      treatment, whether medically necessary or not.
                    </p>
                    <p style={{ padding: '10px' }}>
                      • You have been diagnosed with a terminal illness prior to the date you took out this insurance or
                      booked your trip (whichever is later).
                    </p>
                    <p style={{ padding: '10px' }}>
                      If we are unable to cover a medical condition, this will mean that any person insured with us will
                      not be able to make a claim arising from the medical condition(s).
                    </p>
                  </p>
                )}
              </Row>
            </div>

            {medicalFooter &&  (
              <div className="section padding-bottom-0" style={{ paddingTop: '0' }}>
                <Row>
                  <ReactMarkdown
                    source={medicalFooter}
                    renderers={{
                      link: (props) => (
                        <a href={props.href} target="_blank">
                          {props.children}
                        </a>
                      ),
                    }}
                  />
                </Row>
              </div>
            )}

            {product.productCode !== 'LSB' && (
              <div className="medical-condition-container" hidden={!this.shouldShowScreeningSection()}>
                <div className="section-title">
                  <h2>Medical Screening</h2>
                </div>
                <div className="section">
                  <Row>
                      <p>
                          Your answers to the previous questions indicate that you or one of your travel companions
                          has a medical condition that needs to be covered.
                      </p>
                      <p>
                          Please declare <strong>all</strong> of your medical conditions below, <strong>please note:
                          </strong> if you do not answer all
                          questions honestly this could result in your policy being cancelled or considered not valid.
                      </p>
                  </Row>
                </div>

                <FieldArray
                  name="travellers"
                  i18n={i18n}
                  change={change}
                  channel={channel}
                  component={TravellersMedical}
                  questions={metadata.medical_declaration_questions}
                  setIsScreening={this.setIsScreening}
                  rerenderOnEveryChange={true}
                />
                  <div className="section" id="medical-screening-questions">
                      <Row>
                          <p>
                              Once you have declared <strong>all</strong> travellers' medical conditions, please continue
                              with your quote.
                          </p>
                      </Row>
                  </div>
              </div>
            )}
            <div className="btn-bar"  hidden={this.state.isScreening === true}>
              <Button
                id="continue"
                bsStyle="primary"
                onClick={this.checkIfConditionWasDeclared}
                className="pull-right"
                disabled={submitting || (submitFailed && !valid) || isAnyModalOpen}
              >
                Continue <FaChevronRight/>
              </Button>
              <Button type="button" className="btn-back btn-remove-border" onClick={onBack}>
                Back
              </Button>
            </div>
          </div>
          ) : (
            <div className="section">
              <Row className="unable-box">
                <p>
                  Sorry, we are not able to complete your quotation online as we need a few more details.
                </p>
                <p>
                  {renderCallMessage} {channel.phone} quoting <strong>{quote.application.quoteReference}</strong> who
                  will discuss your requirements with you.
                </p>
                <p>
                  We are open Monday to Friday {channel.openingHours}, closed Bank Holidays.
                </p>
              </Row>
            </div>
          )}
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const medicalDeclaration = selector(state, 'medicalDeclaration');
      const travellers = selector(state, 'travellers');
      const steps = selector(state, 'steps');
      const cancelMedicalDeclaration = selector(state, 'cancelMedicalDeclaration');

      return {
        medicalDeclaration,
        travellers,
        steps,
        channel: state.branding.channel,
        quote: state.quote,
        cancelMedicalDeclaration,
      };
    },
    (dispatch) => ({
      dispatch,
      actions: {
        submit: bindActionCreators(submit, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
        reset: bindActionCreators(reset, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
      },
    }),
  ),
])(MedicalDeclaration);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/MedicalDeclaration/index.tsx